var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"schema-form"},[_c('schema-field',{attrs:{"errors":_vm.errors,"schema":_vm.schema},model:{value:(_vm.vModel),callback:function ($$v) {_vm.vModel=$$v},expression:"vModel"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }